import { BackBtn, Loader } from '@nv/basic-components'
import { AdminEventContent, PositionAccordion } from '@nv/components'
import { useCheckVotingOpenStateChange, useGetEvent } from '@nv/hooks'
import { useVoterUserContext } from 'libs/contexts/src/lib/VoterUserContext'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Candidates } from './Candidates/Candidates'
import styles from './VoterCandidatesAndPositions.module.scss'

export const VoterCandidatesAndPositions = () => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const { eventId }: any = useParams()
  const VoterUser = useVoterUserContext().voterUser

  const event = useGetEvent(eventId)
  const { myCandidacy } = event || {}

  const { votingOpen } = useCheckVotingOpenStateChange({
    event,
    closeDate: event?.closeDate,
  })
  const hasVoted = VoterUser.votedInEvents?.includes(event?.tiviId)

  if (!event) return <Loader />

  return (
    <>
      <div className={styles['container']}>
        <div className={styles['back-btn']}>
          <BackBtn />
        </div>
        <div className={styles['header']}>
          <AdminEventContent
            event={event}
            votingOpen={votingOpen}
            title={event.name}
            onSelectEvent={() => {}}
            isHeader
            hasVoted={hasVoted}
          />
        </div>
        <h1>{t('events.labels.candidates')}</h1>
        {event.questions?.map((position, i) => (
          <div key={i} className={styles['position-container']}>
            <PositionAccordion
              positionLabel={position.texts[currentLanguage]}
              position={position}
              isOpenByDefault={true}
              event={event}
              eventId={event.tiviId}
              applied={myCandidacy?.some((candidacy) => candidacy.qid === position.qid)}
              numEndorsements={myCandidacy?.find((candidacy) => candidacy.qid === position.qid)?.endorsements?.length || 0}
              candidacy={myCandidacy?.find((candidacy) => candidacy.qid === position.qid)}
            >
              <Candidates eventId={event.id} qid={position.qid} event={event} />
            </PositionAccordion>
          </div>
        ))}
      </div>
    </>
  )
}
